import React from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';

import Divider from '../../Shared/UI/Divider/components/Divider';
import Button from '../../Shared/UI/Button/components/Button';
import PlusIcon from '../../Shared/UI/PlusIcon/components/PlusIcon';
import ProfileUserExperience from './ProfileUserExperience';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import NewUserExperienceForm from './NewUserExperienceForm';
import UpdateUserExperienceForm from './UpdateUserExperienceForm';
import DeleteUserExperienceForm from './DeleteUserExperienceForm';

import styles from './ProfileUserExperiences.module.scss';

const ProfileUserExperiences = () => {
  const state = useProfileState();
  const { openNewUserExperienceModal, closeNewUserExperienceModal, closeUpdateUserExperienceModal, closeDeleteUserExperienceModal } = useProfileActions();

  const titleStyling = state?.user?.experiences?.length ? null : styles.visibleOnlyToYou;

  if (state.loading) {
    return (
      <section id={styles.userExperiencesSection}>
        <Divider />
        <div id={styles.userExperiencesLoading} />
      </section>
    );
  }

  return (
    <>
      {(state?.user?.experiences?.length || state?.user?.isAuthenticatedUser) && (
        <section id={styles.userExperiencesSection}>
          <Divider />
          <div id={styles.userExperiencesSectionHeader}>
            <h2 className={titleStyling}>
              Experiences
            </h2>
            {state?.user?.isAuthenticatedUser && (
              <Button
                variant="ghost"
                icon={<PlusIcon />}
                iconOnly
                aria-label="Add Experience"
                onClick={() => {
                  if (state?.user?.isAuthenticatedUser) {
                    openNewUserExperienceModal();
                  }
                }}
              />
            )}
          </div>
          {state?.user?.experiences?.length ? (
            <div id={styles.userExperiences}>
              {state?.user?.experiences?.map((experience, index) => {
                if (index === state?.user?.experiences.length - 1) {
                  return <ProfileUserExperience key={experience.id} experience={experience} />;
                }

                return (
                  <>
                    <ProfileUserExperience key={experience.id} experience={experience} />
                    <Divider variant="secondary"/>
                  </>
                );
              })}
            </div>
          ) : (
            <p className={styles.visibleOnlyToYou}>
              This section is currently only visible to you since you have not claimed any experiences to display yet.
            </p>
          )}
        </section>
      )}
      <StandardModal
        isOpen={state?.newUserExperienceModalIsOpen}
        contentLabel={'Add Your Experience'}
        onRequestClose={() => {
          if (state?.user?.isAuthenticatedUser) {
            closeNewUserExperienceModal();
          }
        }}
      >
        <NewUserExperienceForm />
      </StandardModal>
      <StandardModal
        isOpen={state?.updateUserExperienceModalIsOpen}
        contentLabel={'Update Your Experience'}
        onRequestClose={() => {
          if (state?.user?.isAuthenticatedUser) {
            closeUpdateUserExperienceModal();
          }
        }}
      >
        <UpdateUserExperienceForm />
      </StandardModal>
      <StandardModal
        isOpen={state?.deleteUserExperienceModalIsOpen}
        contentLabel={'Delete This Experience'}
        onRequestClose={() => {
          if (state?.user?.isAuthenticatedUser) {
            closeDeleteUserExperienceModal();
          }
        }}
      >
        <DeleteUserExperienceForm />
      </StandardModal>
    </>
  );
};

export default ProfileUserExperiences;
